import { useState } from "react";
import Button from "../../../Buttons/Button";
import Modal from "../../../Modal/Modal";
import FormFieldSet from "../../../FormFields/FormFieldSet";

const MultipleReminders = ({ onClose, isOpen }) => {
    const [textEditor,setTextEditor] =useState()
  
  return (
    <Modal
      title={"SEND MULTIPLE REMINDERS "}
      onClose={onClose}
      isOpen={isOpen}
      width="max-w-4xl"
    >
      <div>
        <div className="min-h-[250px]">
          {/* <h6>text editor</h6> */}
          <FormFieldSet
            type={"textEditor"}
            value={textEditor}
            onChange={(e) => {
              console.log("TextEditor onChange value:", e);
              setTextEditor(e);
            }}
            noTitle
          />
        </div>
        <div className="flex gap-3 justify-end my-8">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="Submit" onClick={() => {}} />
        </div>
      </div>
    </Modal>
  );
};

export default MultipleReminders;
